// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapPOIS_wrapper__3UpHc","map_title_style":"MapPOIS_map_title_style__YeU7Y"};